export default "__VITE_ASSET__BBRqvvBe__"